export default __webpack_public_path__ + "static/media/plans.da39a98c.svg";